import { render } from "./Selectself.vue?vue&type=template&id=51f51eee&scoped=true"
import script from "./Selectself.vue?vue&type=script&lang=js"
export * from "./Selectself.vue?vue&type=script&lang=js"

import "./Selectself.vue?vue&type=style&index=0&id=51f51eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f51eee"]])

export default __exports__